export default {"src":"/login-app/[GIT_HASH]/_next/static/media/flag.bb7b17bf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};